import http from "@/api/http.js";

export function getAvailableOrders(params = {}) {
  return http.get("/delivery/orders_available", { params }).then(r => r.data);
}

export function getTrips(params = {}) {
  return http.get("/delivery/trips", { params }).then(r => r.data);
}

export function getTrip(uuid) {
  return http.get(`/delivery/trip/${uuid}`).then(r => r.data);
}

export function createTrip(data = {}) {
  return http.post("/delivery/trip", data).then(r => r.data);
}

export function addOrdersToTrip(tripUuid, orderUuids) {
  return http
    .post(`/delivery/trip_orders/${tripUuid}`, { order_uuids: orderUuids })
    .then(r => r.data);
}

export function removeOrderFromTrip(tripUuid, orderUuid) {
  return http
    .delete(`/delivery/trip_order/${tripUuid}/${orderUuid}`)
    .then(r => r.data);
}

export function startTrip(tripUuid) {
  return http.post(`/delivery/trip_start/${tripUuid}`).then(r => r.data);
}

export function completeTrip(tripUuid) {
  return http.post(`/delivery/trip_complete/${tripUuid}`).then(r => r.data);
}

export function cancelTrip(tripUuid) {
  return http.post(`/delivery/trip_cancel/${tripUuid}`).then(r => r.data);
}

export function markDelivered(tripUuid, orderUuid, data = {}) {
  return http
    .post(`/delivery/deliver/${tripUuid}/${orderUuid}`, data)
    .then(r => r.data);
}

export function markFailed(tripUuid, orderUuid, data = {}) {
  return http
    .post(`/delivery/fail/${tripUuid}/${orderUuid}`, data)
    .then(r => r.data);
}

export function optimizeRoute(tripUuid, data = {}) {
  return http
    .post(`/delivery/optimize_route/${tripUuid}`, data)
    .then(r => r.data);
}
